module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [_c('submenu'), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Label_EmailAddress",
      "validate": _vm.$v.model,
      "placeholder": "Placeholder_Email",
      "modelPath": "emailAddress",
      "acc": "emailAddress"
    },
    on: {
      "input": _vm.$v.model.emailAddress.$touch
    },
    model: {
      value: (_vm.model.emailAddress),
      callback: function($$v) {
        _vm.$set(_vm.model, "emailAddress", $$v)
      },
      expression: "model.emailAddress"
    }
  }), _vm._v(" "), (_vm.createMode) ? _c('TextBox', {
    attrs: {
      "label": "Label_Password",
      "validate": _vm.$v.model,
      "modelPath": "password",
      "acc": "password",
      "type": "password"
    },
    on: {
      "input": _vm.$v.model.password.$touch
    },
    model: {
      value: (_vm.model.password),
      callback: function($$v) {
        _vm.$set(_vm.model, "password", $$v)
      },
      expression: "model.password"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.createMode) ? _c('TextBox', {
    attrs: {
      "label": "Label_ConfirmPassword",
      "validate": _vm.$v.model,
      "modelPath": "confirmPassword",
      "acc": "confirmPassword",
      "type": "password"
    },
    on: {
      "input": _vm.$v.model.confirmPassword.$touch
    },
    model: {
      value: (_vm.model.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.model, "confirmPassword", $$v)
      },
      expression: "model.confirmPassword"
    }
  }) : _vm._e(), _vm._v(" "), _c('CheckBox', {
    attrs: {
      "label": "Label_IsActive",
      "acc": "isActive"
    },
    model: {
      value: (_vm.model.isActive),
      callback: function($$v) {
        _vm.$set(_vm.model, "isActive", $$v)
      },
      expression: "model.isActive"
    }
  }), _vm._v(" "), (!_vm.createMode) ? _c('CheckBox', {
    attrs: {
      "label": "Label_IsEmailConfirmed",
      "acc": "isEmailConfirmed"
    },
    model: {
      value: (_vm.model.isEmailConfirmed),
      callback: function($$v) {
        _vm.$set(_vm.model, "isEmailConfirmed", $$v)
      },
      expression: "model.isEmailConfirmed"
    }
  }) : _vm._e(), _vm._v(" "), _c('Btn', {
    attrs: {
      "isLoading": _vm.loading,
      "label": "Label_SaveButton"
    },
    on: {
      "click": _vm.save
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Label_CancelButton",
      "withBorder": true
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'users'
        })
      }
    }
  }), _vm._v(" "), (!_vm.createMode && !_vm.user.isEmailConfirmed) ? _c('Btn', {
    attrs: {
      "label": "ResendConfirmEmail",
      "float": "right",
      "withBorder": true
    },
    on: {
      "click": _vm.resendConfirmEmail
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-285b9560!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/account/User.vue
// module id = 718
// module chunks = 1